import { useState } from "react";
import { ChevronLeft, ChevronRight, HardHat } from "lucide-react";
import { Btn } from "@/components/rp";

const DAYS = ["Lun", "Mar", "Mer", "Gio", "Ven", "Sab", "Dom"];
const key = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
const TONE = { richiesto: "bg-[#FFF3CD] text-[#7A5600]", confermato: "bg-[#070707] text-white", completato: "bg-[#D1E7DD] text-[#0F5132]", annullato: "bg-[#EBEBEB] text-[#757575] line-through" };

const events = (appts, orderAppts) => {
  const m = {};
  for (const a of appts) {
    const d = new Date(a.date);
    (m[key(d)] ||= []).push({ id: a.id, time: d.toLocaleTimeString("it-IT", { hour: "2-digit", minute: "2-digit" }), title: `${a.title} · ${a.client_name}`, tone: TONE[a.status], a });
  }
  for (const o of orderAppts) {
    if (!o.date || o.status === "annullato") continue;
    (m[o.date.slice(0, 10)] ||= []).push({ id: o.id, time: o.start_time, title: `${o.order_code} · ${o.client_name}`, tone: "bg-[#E6DDCE] text-black", o });
  }
  Object.values(m).forEach((l) => l.sort((x, y) => (x.time || "").localeCompare(y.time || "")));
  return m;
};

const DayCell = ({ d, month, list, today, onDay, onEvent }) => (
  <div onClick={() => onDay(d)} className={`min-h-[72px] sm:min-h-[112px] p-1 sm:p-2 border-b border-r border-[#EBEBEB] cursor-pointer hover:bg-[#F7F7F7] transition-colors ${d.getMonth() !== month ? "bg-[#FAFAFA] text-[#B0B0B0]" : ""}`} data-testid={`cal-day-${key(d)}`}>
    <span className={`inline-flex h-6 w-6 items-center justify-center rounded-full text-xs font-semibold ${key(d) === today ? "bg-[#070707] text-white" : ""}`}>{d.getDate()}</span>
    <div className="space-y-1 mt-1">
      {(list || []).slice(0, 3).map((e) => (
        <button type="button" key={e.id} onClick={(ev) => { ev.stopPropagation(); onEvent(e); }} className={`w-full text-left rounded-md px-1.5 py-0.5 text-[10px] sm:text-xs truncate flex items-center gap-1 ${e.tone}`} data-testid={`cal-event-${e.id}`}>
          {e.o && <HardHat className="h-3 w-3 shrink-0" />}<span className="hidden sm:inline font-semibold">{e.time}</span> <span className="truncate">{e.title}</span>
        </button>
      ))}
      {(list || []).length > 3 && <p className="text-[10px] text-[#757575] px-1">+{list.length - 3} altri</p>}
    </div>
  </div>
);

export const CalendarioMese = ({ appts, orderAppts, onDay, onEvent }) => {
  const [cur, setCur] = useState(() => { const d = new Date(); return new Date(d.getFullYear(), d.getMonth(), 1); });
  const start = new Date(cur);
  start.setDate(1 - ((cur.getDay() + 6) % 7));
  const cells = Array.from({ length: 42 }, (_, i) => new Date(start.getFullYear(), start.getMonth(), start.getDate() + i));
  const map = events(appts, orderAppts);
  const shift = (n) => setCur(new Date(cur.getFullYear(), cur.getMonth() + n, 1));
  return (
    <div className="rp-card overflow-hidden" data-testid="agenda-calendar">
      <div className="flex items-center gap-2 p-4 border-b border-[#EBEBEB]">
        <p className="text-lg font-semibold capitalize flex-1" data-testid="cal-month-label">{cur.toLocaleDateString("it-IT", { month: "long", year: "numeric" })}</p>
        <Btn variant="secondary" className="h-9" onClick={() => { const d = new Date(); setCur(new Date(d.getFullYear(), d.getMonth(), 1)); }} data-testid="cal-today">Oggi</Btn>
        <Btn variant="secondary" className="h-9 w-9 p-0" onClick={() => shift(-1)} aria-label="Mese precedente" data-testid="cal-prev"><ChevronLeft className="h-4 w-4" /></Btn>
        <Btn variant="secondary" className="h-9 w-9 p-0" onClick={() => shift(1)} aria-label="Mese successivo" data-testid="cal-next"><ChevronRight className="h-4 w-4" /></Btn>
      </div>
      <div className="grid grid-cols-7 border-l border-[#EBEBEB]">
        {DAYS.map((d) => <p key={d} className="rp-label text-center py-2 border-b border-r border-[#EBEBEB]">{d}</p>)}
        {cells.map((d) => <DayCell key={key(d)} d={d} month={cur.getMonth()} list={map[key(d)]} today={key(new Date())} onDay={onDay} onEvent={onEvent} />)}
      </div>
      <p className="text-xs text-[#757575] p-3">Clicca su un giorno per fissare un appuntamento, su un appuntamento per modificarlo o invitare persone. Gli appuntamenti con l'elmetto sono di un cantiere: si gestiscono dalla sua scheda.</p>
    </div>
  );
};
